module.exports = __webpack_public_path__ + "img/PL00212.e4d93c1e.svg";